import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import store from '../store';
import AssetsCopyDialog from '../components/AssetsCopyDialog';

/** Show assets copy options dialog */
export default function showAssetsCopyDialog(props) {
  const parentEl = document.querySelector('.wrapperDownloadDialog');
  const root = createRoot(parentEl);

  function destroy() {
    root.unmount();
  }

  root.render(
    <Provider store={store}>
      <AssetsCopyDialog destroy={destroy} {...props} />
    </Provider>,
  );
}
